<div class="footer-container">
  <div class="content-copyright mobile">
    <span>{{pageTranslations?.footerContainerTranslation?.copyrightTextAfterYear}} ©{{year}} {{pageTranslations?.footerContainerTranslation?.copyrightTextBeforeYear}}</span>
    <span>
      <a
        class="terms"
        [href]="policyUsageUrl"
        rel="noreferrer nofollow"
        target="_blank"
      >{{pageTranslations?.footerContainerTranslation?.usagePolicyText}}</a>
    </span>

  </div>

  <div class="content-copyright desktop">
    <span>{{pageTranslations?.footerContainerTranslation?.copyrightTextAfterYear}} ©{{year}} {{pageTranslations?.footerContainerTranslation?.copyrightTextBeforeYear}}</span>
    <div class="divider">|</div>

    <span>
      <a
        class="terms"
        [href]="policyUsageUrl"
        target="_blank"
      >{{pageTranslations?.footerContainerTranslation?.usagePolicyText}}</a>
     
    </span>
  </div>

  <div class="flex-spacer"></div>

  <div class="duvidas-frequentes"><div class="divider">|
    <a style="margin-left: 2.5px;" href="https://pages.unhideschool.com/faq-unhideschool/categories/termos"
      target="_blank">Termos e Condições de
      Uso</a></div>
  </div>

  

  <div class="duvidas-frequentes">

    <div class="divider" style="
    margin-right: 10px;
  ">|</div>

  <div class="duvidas-frequentes--icon">?</div>

  <a href="https://pages.unhideschool.com/faq-unhideschool/categories/faq" target="_blank">Dúvidas frequentes</a>

  </div>

  <a class="unh-button-old faq" theme="transparent-grey" href="https://pages.unhideschool.com/faq-unhideschool/categories/faq/"  target="_blank"
  >
  {{pageTranslations?.footerContainerTranslation?.faqText}}
  </a>

  <unh-social-menu></unh-social-menu>
</div>
